/* eslint-disable @typescript-eslint/naming-convention */

/**
 * @description Routes de l'API
 */
export const routes = {
    home: '/home',
    news: '/news',
    page: '/page',

    vegetable: {
        list: '',
        product: '',
    },

    product: {
        list: '/product-lists',
        articles: '/product-articles',
    },
    recipe: {
        list: '/recipe-lists',
        articles: '/recipe-articles',
        pdf: '/pdf/recipe',
        home: '/recipe-home'
    }
}

export type HrefLang = { lang: string, url: string }

export const hrefLangs: HrefLang[] = [
    { lang: 'fr', url: 'https://www.bonduelle.fr' },
    { lang: 'de', url: 'https://www.bonduelle.de' },
    { lang: 'nl-BE', url: 'https://www.bonduelle.be' },
    { lang: 'nl', url: 'https://www.bonduelle.nl' },
    { lang: 'hu', url: 'https://www.bonduelle.hu' },
    { lang: 'it', url: 'https://www.bonduelle.it' },
    { lang: 'cs', url: 'https://www.bonduelle.cz' },
    { lang: 'sk', url: 'https://www.bonduelle.sk' },
    { lang: 'da', url: 'https://www.bonduelle.dk' },
    { lang: 'de-AT', url: 'https://www.bonduelle.at' },
    { lang: 'pt', url: 'https://www.bonduelle.pt' },
    { lang: 'es', url: 'https://www.bonduelle.es' },
    { lang: 'lt', url: 'https://www.bonduelle.lt' },
    { lang: 'lv', url: 'https://www.bonduelle.lv' },
    { lang: 'et', url: 'https://www.bonduelle.ee' },
    { lang: 'fi', url: 'https://www.bonduelle.fi' },
    { lang: 'no', url: 'https://www.bonduelle.no' },
    { lang: 'sv', url: 'https://www.bonduelle.se' },
    { lang: 'pl', url: 'https://www.bonduelle.pl' },
    { lang: 'sr', url: 'https://www.bonduelle.rs' },
    { lang: 'sq', url: 'https://www.bonduelle.al' },
    { lang: 'el', url: 'https://www.bonduelle.gr' },
    { lang: 'ro', url: 'https://www.bonduelle.ro' },
    { lang: 'hr', url: 'https://www.bonduelle.hr' },
    { lang: 'bg', url: 'https://www.bonduelle.bg' },
    { lang: 'bs', url: 'https://www.bonduelle.ba' },
    { lang: 'uk', url: 'https://www.bonduelle.ua' },
    { lang: 'br', url: 'https://www.bonduelle.br' },
    { lang: 'x-default', url: 'https://www.bonduelle.fr' }
];

export const corporateLinks = {
    1460: 'https://engagements.bonduelle.fr/engagement/origine-france-respect-des-saisons/',
    1624: 'https://engagements.bonduelle.fr/engagement/reduction-pesticides/',
    1625: 'https://engagements.bonduelle.fr/engagement/sauvegarder-biodiversite/',
    1626: 'https://engagements.bonduelle.fr/engagement/reduire-les-additifs/',
    1627: 'https://engagements.bonduelle.fr/engagement/agriculture-biologique/',
    1628: 'https://engagements.bonduelle.fr/engagement/emballages-plus-respectueux-de-la-planete/',
}